import type { BillingRouter } from "replo-publisher/src/trpc/routers/billing";

import { getNamespacedQueryClient } from "@v2/trpc/trpc";

import { createTrpcRouterConfig } from "../config";

const {
  router: billingRouter,
  client: billingClient,
  utils: billingUtils,
  options: billingOptions,
} = createTrpcRouterConfig<BillingRouter>({
  path: "billing",
  queryClient: getNamespacedQueryClient("billing"),
});

export { billingClient, billingRouter, billingUtils, billingOptions };
